import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../enums';
import ResponsiveLayout from '../../Common/ResponsiveLayout/ResponsiveLayout';
import { Autosuggest as AutosuggestComponent } from '../../Common/Autosuggest/Autosuggest';

export const Autosuggest = styled(AutosuggestComponent)`
	flex: 4;

	.autosuggest__input {
		background-color: ${palette.mlcPartner};
		color: ${palette.mlcWhite};
		flex: 1;
		font-size: 16px;
		height: 44px;
		padding: 0 10px;
		text-overflow: ellipsis;
	}

	.autosuggest__input::-ms-clear {
		display: none;
	}

	.autosuggest__suggestions-container {
		color: ${palette.mlcPartner};
	}

	.InputWrapper {
		margin-bottom: 0;
	}

	.autosuggest__suggestions-container--open {
		background-color: ${palette.mlcWhite};
		box-shadow: 0 1px 3px 0 ${palette.mlcPartner};
		top: 52px;
		width: 100%;
	}

	.autosuggest__suggestion {
		border-bottom: 0.3px solid #979797;
		font-size: 18px;
		padding: 10px 20px;
	}

	.autosuggest__suggestion--highlighted {
		background-color: ${palette.mlcKoala};
		color: ${palette.mlcAqua};
		text-decoration: underline;
	}

	.autosuggest__section-title {
		font-size: 13px;
		margin: 5px 0 0;
		padding: 6px 4px;
	}

	.autosuggest__container {
		display: flex;
		flex: 1;
		flex-direction: column;
	}
`;

export const SearchButton = styled.button`
	&:hover,
	&:focus {
		background: ${palette.mlcDeepOrange};
		border: 1px solid ${palette.mlcDeepOrange};
		outline: 0;
		text-decoration: underline;
		transition: all 0.25s linear;
	}

	&::before {
		background: ${palette.mlcOrange};
		content: '';
		height: 15px;
		position: absolute;
		right: 20px;
		top: -7px;
		transform: rotate(45deg);
		width: 15px;
	}

	&:hover::before,
	&:focus::before {
		background: ${palette.mlcDeepOrange};
		transition: all 0.25s linear;
	}

	align-items: center;
	background: ${palette.mlcOrange};
	border: 1px solid ${palette.mlcOrange};
	border-radius: 0;
	box-shadow: none;
	color: ${palette.mlcWhite};
	cursor: pointer;
	display: flex;
	flex: 1;
	font-size: 16px;
	height: 44px;
	justify-content: center;
	padding: 0 20px;
	padding-left: 15px;
	width: 100%;

	@media (max-width: ${ScreenSize.small}) {
		&::before {
			right: 20px;
		}
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		flex-grow: 0;
		min-width: 135px;

		&::before {
			left: 30px;
		}
	}
`;

export const SearchForm = styled.form`
	display: flex;
	flex-wrap: row;
	margin-top: 11px;
	top: 60px;
	width: 390px;

	@media (max-width: ${ScreenSize.xSmall}) {
		width: 100%;
	}
`;

export const ResponsiveContainer = styled(ResponsiveLayout)`
	top: 50px;

	@media (max-width: ${ScreenSize.xSmall}) {
		left: 0 !important;
		right: 0 !important;
		width: 100% !important;
	}
`;

export const AutosuggestResultItem = styled.div`
	padding: 8px;
`;

export const LoadingWrapper = styled.div`
	position: absolute;
	right: 0;
	top: 14px;
`;

export const InputContainer = styled.div`
	display: flex;
	flex: 1;
	position: relative;
`;

export const SearchButtonContainer = styled.div`
	flex: 1;
	position: relative;
`;
